// Pure helper for the Salesperson "Create New" employee auto-suggest select.
// Kept free of React/redux so the option-shaping and Sales-role filtering can be
// unit tested in isolation (mirrors the *Helpers pattern used by the dashboard widgets).
//
// Business rule: the salesperson auto-suggest lists only employees whose role is
// "Sales" and who are not deleted. Each employee becomes a react-select option
// shaped { value: userId, label: userName, email, employeeId }.
export const buildEmployeeOptions = (employeeList) => {
  if (!Array.isArray(employeeList)) return [];
  return employeeList
    .filter((emp) => emp && emp.roleName === "Sales" && emp.isDeleted !== true)
    .map((emp) => ({
      value: emp.userId,
      label: emp.userName,
      email: emp.email,
      employeeId: emp.employeeId,
    }));
};
